export default __webpack_public_path__ + "static/media/c4t.bce56daa.png";